export default "__VITE_ASSET__BZ0$8_so__"